import { HttpBaseService } from "../../../Common/services/http-base-service";
import { TrackingBaseData } from "../Models/tracking-base-data";
declare var APIURL;
declare const window: any;
export class TrackingService {
    static async getBaseData(pageName: string): Promise<TrackingBaseData> {
        return await HttpBaseService.get<TrackingBaseData>(`${APIURL}/trackings?pageName=${pageName}`);
    }

    private static sendDataToGtm(data: any) {
        if (data) {
            window.dataLayer.push(data);
        }
    }

    private static mapExtra(event: GtmEvent, extra: any) {
        switch (event) {
            default:
                return extra;
        }
    }

    public static logEvent(event: GtmEvent, extra?: any) {
        try {
            const data = Object.assign({ event: event }, this.mapExtra(event, extra));
            // remove undefined values from json
            var dataReturn = JSON.parse(JSON.stringify(data));
            this.sendDataToGtm(dataReturn);
        } catch (error) {
            return;
        }
    }

}

export enum GtmEvent {
    PageView = "datalayer_ready",
    Update = "datalayer_update",
    Search = "search",
    ClickItem = "click_item",
    AddToCart = "add_to_cart",
    ClickMenu = "click_menu",
    ClickMerch = "click_merch",
    Click = "click",
    AddBrandAlert = "add_to_brand_alert",
    ClickFilter = "click_filter"
}

export enum GtmEventType {
    Submit = "submit",
    Redirect = "redirect",
    Suggestion = "suggestion", // products suggested in searchbar
    Autocomplete = "autocomplete",
    Breadcrumb = "breadcrumb",
    Item = "item",
    Brand= "brand"
}

export enum GtmEventValue {
    Item = "item",
    ItemView = "item_view",
    Sale = "sale",
    SaleView = "sale_view",
    Search = "search",
    History = "history",
    QuerySuggestion = "query_suggestion",
    Page = "page",
    AllItems = "all_items",
    Universe = "universid",
    Menu = "menu",
    Header = "header",
}

